export const hasAccessToEsignatureModule = ['ESSP', 'ESDRO', 'ESASM', 'DEDRO', 'DEASM', 'GBDRO', 'GBASM', 'GBCNT', 'DECNT', 'ESCNT', 'DESP', 'GBSP', 'PTSP', 'PTDRO', 'PTASM', 'PTCNT'];

export const hasAccessToProposalTrackingModule = ['ESDRO', 'DEDRO', 'GBDRO', 'GBCNT', 'DECNT', 'ESCNT', 'PTCNT', 'PTDRO'];
